import * as Types from './types';

export const openAuthModal = ({ loginRedirectUrl, currentForm }) => ({
  type: Types.OPEN_AUTH_MODAL,
  payload: { loginRedirectUrl, currentForm }
});

export const closeAuthModal = () => ({
  type: Types.CLOSE_AUTH_MODAL
});

export const setCurrentForm = form => ({
  type: Types.SET_CURRENT_AUTH_MODAL_FORM,
  payload: form
});
